import React, { Component } from 'react';
import * as d3 from 'd3';

import ChartSpecs from '../data/chart_specs';

import VillagerAvatar from '../components/VillagerAvatar';
import Dialogue from '../components/Dialogue';

//images
import ImgBob from '../images/villagers/Bob.png';

const margin = ChartSpecs.chartspecs.margin;
const areaMargin = ChartSpecs.chartspecs.marginAreabars;

//REMOVE WA*
//For distribution: mono tone
//For stackchart, only one pop color
var gameArray = [
    {'code':"DNM",
     'name':'Doubutsu no mori (Japan original)',
     'release': '2001',
     'color':'#017c74'
    },
    {'code':"AC",
     'name':'Animal Crossing (North America release)',
     'release': '2001',
    'color':'#017c74'
    },
    {'code':"E_PLUS",
     'name':'Doubutsu no mori e+ (Japan exclusive)',
     'release': '2003',
     'color':'#017c74'
    },
    {'code':"WW",
     'name':'Animal Crossing: Wild World',
     'release': '2005',
     'color':'#017c74'
    },
    {'code':"CF",
     'name':'Animal Crossing: City Folk',
     'release': '2008',
     'color':'#017c74'
    },
    {'code':"NL",
     'name':'Animal Crossing: New Leaf',
     'release': '2012',
     'color':'#017c74'
    },
    {'code':"WA",
     'name':'Animal Crossing: New Leaf - Welcome Amiibo',
     'release': '2016',
     'color':'#febdc3'
    },
    {'code':"NH",
     'name':'Animal Crossing: New Horizons',
     'release': '2020',
     'color':'#017c74'
    },
  //{'code':"Previous",
  // 'name':'All Previous Games',
  // 'color':'#8DC5F8'
  // },
];


const gameYearObj = gameArray.sort((a,b)=>Number(b.release)-Number(a.release)).reduce(function(result, game, index) {
  var gamecode = Object.values(game)[0]; //first property: code
  var color = Object.values(game)[2]; //third property: color
  result[gamecode] = color;
  return result;
}, {});

const gameNameObj = gameArray.reduce(function(result, game, index) {
  var gamecode = Object.values(game)[0]; //first property: code
  var name= Object.values(game)[1]; //second property: name
  result[gamecode] = name;
  return result;
}, {});


let recentGameObj = Object.keys(gameYearObj).reduce((p, c) => {
   if (Number(gameYearObj[c])>=2016) p[c] = gameYearObj[c];
   return p;
   }, {});

let olderGameObj = Object.keys(gameYearObj).reduce((p, c) => {
  if (Number(gameYearObj[c])<2016) p[c] = gameYearObj[c];
  return p;
  }, {});

let allGameObj = Object.keys(gameYearObj).reduce((p, c) => {
  if (Number(gameYearObj[c])<2022) p[c] = gameYearObj[c];
  return p;
  }, {});

var olderGameArray = Object.keys(olderGameObj);
var recentGameArray = Object.keys(recentGameObj);
var allGameArray = Object.keys(allGameObj);

class VillagerDebutgame extends Component {
  constructor(props){
      super(props);
      //this.svgRef = React.createRef();
      this.state = {
        selectedTier:1,
      }

      this.allVillagers = this.props.villagers;

      this.dataSet = [];

      this.tierNodes = d3.groups(this.allVillagers, d => d.tier, d => d.debut);
      this.tierNodes2 = d3.rollup(this.allVillagers, v => v.length, d => d.tier, d => d.debut);
      this.tierArray = [...this.tierNodes2.keys()];

   }

   componentDidMount() {
     this.svg = d3.select(`#debutChart`);
     this.drawDistributionChart();
     //this.drawOverlapAreaChart();
   }

   sliderRangeHandler(event){
      let selectedTier = event.target.value;
      this.setState({selectedTier: selectedTier});
      this.highlightTierBar(selectedTier);
   }

   highlightTierBar(selectedTier){
     let tableData = this.dataSet,
         tierArray = this.tierArray,
         chartWidth = this.svg.node().getBoundingClientRect().width,
         totalBarGroups = allGameArray.length,
         stackKeys = allGameArray,
         noOfColumns = 2,
         svg = this.svg;

     let noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);


     const yMaxArray = stackKeys.map(debut => {
       let max = d3.max(tableData, d => d[debut])
       return max;
     });

      const yMax = d3.max(yMaxArray, d => d);


     const xScale = d3.scaleBand()
                     .domain(tierArray)
                     .range([0, chartWidth/noOfColumns - margin.right])
                     //.padding(0.5)

      // Get the index of the xValue relative to the dataSet
      const dataIndex = tableData.findIndex(obj => obj.tier === Number(selectedTier))

    //  const leftData = (dataIndex === 0)? 0 :tableData[dataIndex-1];
      const leftData = tableData[dataIndex];
      const rightData = (dataIndex === 9)? 'max':tableData[dataIndex + 1];

      if(rightData === 'max'){
          svg.selectAll(".start").attr("offset", `${90}%`);
          svg.selectAll(".end").attr("offset", `${100}%`);
        }else{
          // Update gradient
          const x1Percentage = xScale(leftData.tier) / (chartWidth/noOfColumns - margin.right)  * 100;
          const x2Percentage = xScale(rightData.tier) / (chartWidth/noOfColumns - margin.right)  * 100;
          svg.selectAll(".start").attr("offset", `${x1Percentage}%`);
          svg.selectAll(".end").attr("offset", `${x2Percentage}%`);
        }
   }

   drawDistributionChart(){

     let svg = this.svg;

     var chartWidth = svg.node().getBoundingClientRect().width,
         stackKeys = allGameArray,
         singleChartHeight = 40,
         strokeColor = 'rgba(1,124,116,1)',
         fillColor = 'rgba(1,124,116,0.5)',
         fillColorLight = 'rgba(1,124,116,0.1)',
         totalBarGroups = allGameArray.length,
         noOfColumns = 2;

     const defs = svg.append("defs");

     const gradient = defs.append("linearGradient").attr("id", `svgGradientdebutChart`);
     const gradientResetPercentage = "50%";

     let imageWrapper = defs.append("g").attr("class", "image-group-wrapper");

     imageWrapper.selectAll(".debut-thumbnail-image")
       .data(gameArray)
       .join("pattern")
       .attr("id", d => `villager-debut-${d.code}`)
       .attr("class", "thumbnail-image debut-thumbnail-image")
       //.attr("patternUnits", "objectBoundingBox")
       .attr("height", "100%")
       .attr("width", "100%")
       .attr('patternContentUnits', 'objectBoundingBox')
       .append("image")
       .attr("xlink:href", function(d,i) {
         return process.env.PUBLIC_URL + `/images/debut/${d.code}.png`
         //return require(`../images/${d}.png`)
       })
       .attr('preserveAspectRatio', 'xMidYMin slice')
       .attr("height", 1)
       .attr("width", 1);

     gradient
       .append("stop")
       .attr("class", "start")
       .attr("offset", gradientResetPercentage)
       .attr("stop-color", fillColorLight);

     gradient
       .append("stop")
       .attr("class", "start")
       .attr("offset", gradientResetPercentage)
       .attr("stop-color", fillColor);

     gradient
       .append("stop")
       .attr("class", "end")
       .attr("offset", gradientResetPercentage)
       .attr("stop-color", fillColor)
       .attr("stop-opacity", 1);

     gradient
       .append("stop")
       .attr("class", "end")
       .attr("offset", gradientResetPercentage)
       .attr("stop-color", fillColorLight);


    let  tierNodes2 = this.tierNodes2,
         tierArray = this.tierArray,
         noOfChartsPerCol = Math.round(totalBarGroups/noOfColumns);

    let chartHeight = singleChartHeight*totalBarGroups;

    svg.attr("height", chartHeight + areaMargin.top);

     this.dataSet = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);


     let tableData = this.dataSet;

     const yMaxArray = stackKeys.map(debut => {
       let max = d3.max(tableData, d => d[debut])
       return max;
     });



      const yMax = d3.max(yMaxArray, d => d);


      const xScale = d3.scaleBand()
                      .domain(tierArray)
                      .range([areaMargin.left, chartWidth/noOfColumns - areaMargin.right])
                      //.padding(0.5)

      const yScale = d3.scaleLinear()
                      .domain([ 0, yMax]) //to maintain the same chartHeight, force the domain range to match the popularSpeices chart
                      .range([singleChartHeight, areaMargin.top/singleChartHeight]);

      const xAxis = g => g
                  .call(d3.axisBottom(xScale).tickFormat((d,i) => {
                   return (i%9 !== 0)  ? " ": `T.${d}` ;
                  }).tickSizeOuter(0))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .call(d3.axisLeft(yScale).ticks(2).tickSizeOuter(0).tickFormat(y => `${y.toFixed(0)}`))
                .call(g => g.selectAll(".domain").remove());

      // Creating the clone of the array
      let clonetableData = tableData.slice(0);

      const clonetableDataArr = tableData.map(d => ({ ...d}));

      // Extract the array using splice method
      let tableDataExtended = clonetableDataArr.splice(0,tierArray.length);

      const clonetableDataFirst = tableDataExtended[0];
      const clonetableDataLast = tableDataExtended[tierArray.length-1];

      //let tableDataExtended = tableData.slice();

      tableDataExtended.unshift(clonetableDataFirst);
      tableDataExtended.push(clonetableDataLast);

      let newFirst = tableDataExtended[0],
          newLast = tableDataExtended[tableDataExtended.length-1];

      stackKeys.forEach((debut, index) => {

        // define the area
        let area = d3.area()
            //.x(d => xScale(d.tier))
            .x((d,i) => {
              if(i === 0){
                return xScale.bandwidth()/2 + areaMargin.left/2
              }else if(i === (tableDataExtended.length-1)){
                return xScale(d.tier) + xScale.bandwidth()/2
              }else{
                return xScale(d.tier)
              }
            })
            .y0(yScale(0))
            .y1(d => yScale(d[debut]))
            .curve(d3.curveStep)

        // define the line
        let line = d3.line()
                  .y(d => yScale(d[debut]))
                  .x((d,i) => {
                    if(i === 0){
                      return xScale.bandwidth()/2 + areaMargin.left/2
                    }else if(i === (tableDataExtended.length-1)){
                      return xScale(d.tier) + xScale.bandwidth()/2
                    }else{
                      return xScale(d.tier)
                    }
                  })
                  .curve(d3.curveStep)



       let group = svg.append("g")
         .attr('class', `path-${(debut.indexOf(' ') >= 0)?debut.replace(/ /g,"-"):debut}`); //add dash in Bear cub to generate right class name
       let barLabels = svg.append("g")
           .attr('class', `bar-label-${(debut.indexOf(' ') >= 0)?debut.replace(/ /g,"-"):debut}`)

       let chartLabels = svg.append("g")
           .attr('class', `chart-label-${(debut.indexOf(' ') >= 0)?debut.replace(/ /g,"-"):debut}`)

       // Add the area
       group.append('path')
           .datum(tableDataExtended)
           .attr('class', `path-goodlooking`)
           //.style('fill', fillColorLight)
           .style('fill', `url(#svgGradientdebutChart)`)
           .attr("d",area)

      // Add the line
       group.append("path")
          .datum(tableDataExtended)
          .attr("fill", "none")
          .attr("stroke", strokeColor)
          .attr("stroke-width", 2)
          .attr("d", line)

       chartLabels.append('text')
             .attr('class', 'chart-label')
             //.attr("transform", "rotate(90)")
             .style("font-size",8)
             .style("text-anchor", "left")
             .attr("x", d => 0)
             .attr('y', d => yScale(yMax/2))
             .attr("dy", "0em")
             .text(d => gameNameObj[debut]);

       barLabels.append('rect')
       .attr('class', 'bar-label-container')
       .style('stroke', fillColorLight)
       .style("fill", `url(#villager-debut-${debut})`)
       .attr("transform", `translate(${-areaMargin.right/3},${-areaMargin.top/3})`)
       .attr("width", areaMargin.right/1.5)
       .attr("height", areaMargin.right/1.25);

       barLabels.append('text')
             .attr('class', 'bar-label')
             //.attr("transform", "rotate(90)")
             .style("font-size",7)
             .style("text-anchor", "middle")
             .attr("x", d => 0)
             .attr('y', d => yScale(yMax/2))
             .attr("dy", "1em")
             .text(d => gameYearObj[debut]);
             //.text(function(d) { return `${debut}` });

             if(index < noOfChartsPerCol){
              /* svg.append("g")
               .attr("transform", `translate(${-areaMargin.right/6}, ${chartHeight - areaMargin.top/4})`)
               .attr("class", 'xaxis tier-axis no-tick gap-tick')
               .call(xAxis);*/

               svg.append("g")
               .attr("transform", `translate(${areaMargin.left/1.25}, ${areaMargin.top/noOfColumns + index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4})`)
               .attr("class", 'yaxis')
               .call(yAxis);

               group.attr("transform", `translate(${0  + areaMargin.right/6}, ${areaMargin.top/2 + index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4})`)

               chartLabels.attr("transform", `translate(${areaMargin.left}, ${(singleChartHeight+areaMargin.top/4)+ index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4}) rotate(0)`)


               barLabels.attr("transform", `translate(${chartWidth/noOfColumns - areaMargin.right/2.25}, ${areaMargin.top/1 + index*(chartHeight/noOfChartsPerCol)+ index*areaMargin.top/4}) rotate(0)`)

             }else{
              /* svg.append("g")
               .attr("transform", `translate(${chartWidth/noOfColumns-areaMargin.right/6}, ${chartHeight- areaMargin.top/4})`)
               .attr("class", 'xaxis tier-axis no-tick gap-tick')
               .call(xAxis);*/

              svg.append("g")
               .attr("transform", `translate(${chartWidth/noOfColumns + areaMargin.left/1.25}, ${areaMargin.top/noOfColumns + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4})`)
               .attr("class", 'yaxis')
               .call(yAxis);

               group.attr("transform", `translate(${chartWidth/noOfColumns + areaMargin.right/6}, ${areaMargin.top/2 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4})`)

               chartLabels.attr("transform", `translate(${chartWidth/noOfColumns + areaMargin.left}, ${(singleChartHeight+areaMargin.top/4) + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4}) rotate(0)`)


               barLabels.attr("transform", `translate(${chartWidth - areaMargin.right/2.25}, ${areaMargin.top/1 + (index-noOfChartsPerCol)*(chartHeight/noOfChartsPerCol)+ (index-noOfChartsPerCol)*areaMargin.top/4}) rotate(0)`)

             }

       });

       this.highlightTierBar(this.state.selectedTier);

   }

   drawOverlapAreaChart(){


     let svg = d3.select(`#acnhdebutChart`);

     let chartWidth = svg.node().getBoundingClientRect().width,
         chartHeight = 160,
         stackKeys = recentGameArray,
         radius = 40;

     svg.attr("height", chartHeight);

     let allVillagersGroupedByDebut = d3.rollup(this.allVillagers, d => d.length, d => d.debut);

     let tierNodes2 = this.tierNodes2,
         tierArray = this.tierArray;

      let tableData = Array.from(tierNodes2.entries())
      .map(g => {
        const obj = {};
        obj["tier"] = g[0];
        for (let col of stackKeys) {
          const vals = g[1].get(col);
          obj[col] = !vals ? 0 : vals;
        }
        return obj;
      })
     .sort((a, b) => a["tier"] - b["tier"]);

     const yMaxArray = stackKeys.map(score => {
       let max = d3.max(tableData, d => d[score])
       return max;
     });

      const yMax = d3.max(yMaxArray, d => d);

      const totalBarGroups = stackKeys.length;

      const xScale = d3.scaleBand()
                      .domain(tierArray)
                      .range([margin.left, chartWidth - margin.right])
                      //.padding(0.5)

      const yScale = d3.scaleLinear()
                    .domain([ 0, yMax ])
                    .range([ chartHeight - margin.top, margin.top ])

      const xAxis = g => g
                  .attr("transform", `translate(0,${ chartHeight - margin.top/1.5})`)
                  .call(d3.axisBottom(xScale).tickFormat(function(d,i){ return `T.${d}` }).tickSizeOuter(0))
                  .call(g => g.selectAll(".domain").remove());

      const yAxis = g => g
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(yScale).ticks(3).tickSizeOuter(0))
                .call(g => g.selectAll(".domain").remove());

      svg.append("g")
       .attr("class", 'xaxis tier-axis')
       .call(xAxis);

      svg.append("g")
      .attr("class", 'yaxis tier-axis')
      .call(yAxis);


      stackKeys.forEach((debut, index) => {
        // define the area
        let area = d3.area()
            .x(d => xScale(d.tier))
            .y0(yScale(0))
            .y1(d => yScale(d[debut]))
            .curve(d3.curveBasis)

      // define the line
      let line = d3.line()
                .x(d => xScale(d.tier))
                .y(d => yScale(d[debut]))
                .curve(d3.curveBasis)

                 //.curve(d3.curveStep)
                 //.curve(d3.curveNatural)
                 //.curve(d3.curveBasis)

        let group = svg.append("g")
          .attr('class', `path-${debut}`)
          .attr("transform", `translate(${xScale.bandwidth()/2},${0})`)

           // Add the area
          group.append('path')
             .datum(tableData)
             .attr('class', `path-debut`)
             .style('fill', d => (debut ==='WA')?'#febdc3':'#017c74')
             .style("opacity", 1)
             .attr("d",area)


        // Add the line
         group.append("path")
            .datum(tableData)
            .attr("fill", "none")
            .attr("stroke", d => (debut ==='WA')?'#febdc3':'#017c74')
            .attr("stroke-width", 2)
            .style("opacity", 0)
            .attr("d", line)

     })

   }

  render() {
    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-gameplay">
        <h2 className="title">Villager debut game</h2>
        <p className="paragraph">
        Since its original release in 2001, the Animal Crossing franchise has gained a lot of dedicated fans, and those fans may have favorite villagers from their previous games. For example:
        </p>
        <div className="unique-villager first-villager">
          <img alt='Bob' src={ImgBob}/>
          <span className="description">
            <span className="name">Bob <span className="ranking">15</span></span>
            <span className="sub">He appears in every Animal Crossing game and is popular with fans because he's rumored to be the first villager ever created.</span>
          </span>
        </div>
        <p className="paragraph">
        Given Bob’s fan favorite status, we were curious if villagers who debuted in earlier Animal Crossing games had established fan bases that made them more popular. We looked at the popularity of villagers who debuted in eight of the main Animal Crossing games. </p>
        <div className='tier-slider'>
            <label htmlFor="debutTierSlider" className='slider-label' aria-label="Tier slider"></label>
            <input type="range"
            id="debutTierSlider"
            min="1"
            max="10"
            value={this.state.selectedTier}
            onChange={this.sliderRangeHandler.bind(this)}
            step="1"
            className='slider-input'/>
            <output htmlFor="debutTierSlider" id="debutTierSlider-output" style={{left: `calc(${parseInt(this.state.selectedTier)*10}% - ${(parseInt(this.state.selectedTier)/10)*72}px - ${3.9*(10-parseInt(this.state.selectedTier))}px)`}} className='slider-output'>Tier {this.state.selectedTier}</output>
        </div>
        <svg id='debutChart'  width="100%"></svg>
        <p className="paragraph">
        From our charts, it doesn’t look like villagers who debuted earlier ranked higher in popularity. </p>
        <p className="paragraph"> There is a positive trend for the villagers who debuted in Animal Crossing: New Horizons; as we explained in the previous section, those are the villagers who are newest and don’t have Amiibos. </p>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph">There does not seem to be a significant relationship between when a villager debuted and how popular it is. Bob is the exception here!</p>
        </Dialogue>
      </div>
    )
  }
}

export default VillagerDebutgame;
